export default __webpack_public_path__ + "static/media/voicenote-mobile-3.12fef5c7.png";